var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "site-search", attrs: { id: "site-search" } },
    [
      _c("div", { staticClass: "content-max-width" }, [
        _c(
          "button",
          {
            staticClass: "circle",
            on: {
              click: function($event) {
                return _vm.closeSearch()
              }
            }
          },
          [
            _c("img", {
              attrs: {
                src: "/images/icons/close.svg",
                alt: "Habit Health exit"
              }
            })
          ]
        ),
        _vm._v(" "),
        _c("div", { staticClass: "text-search" }, [
          _c("label", [_vm._v("Start typing to search...")]),
          _vm._v(" "),
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.payload.keyword,
                expression: "payload.keyword"
              },
              {
                name: "debounce",
                rawName: "v-debounce:750ms",
                value: _vm.liveSearch,
                expression: "liveSearch",
                arg: "750ms"
              }
            ],
            ref: "search",
            attrs: { type: "text" },
            domProps: { value: _vm.payload.keyword },
            on: {
              input: function($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.$set(_vm.payload, "keyword", $event.target.value)
              }
            }
          })
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "filters" }, [
          _c("label", [_vm._v("Filter Results")]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "filter-options" },
            [
              _c(
                "a",
                {
                  staticClass: "button navy-border",
                  class: { active: _vm.payload.module_type.length === 0 },
                  on: {
                    click: function($event) {
                      _vm.payload.module_type = []
                      _vm.liveSearch()
                    }
                  }
                },
                [_vm._v("\n          Show all\n        ")]
              ),
              _vm._v(" "),
              _vm._l(_vm.module_type, function(type) {
                return _c(
                  "a",
                  {
                    staticClass: "button navy-border",
                    class: {
                      active:
                        _vm.payload.module_type.includes(type.id) &&
                        _vm.payload.module_type !== []
                    },
                    on: {
                      click: function($event) {
                        return _vm.filter(type.id)
                      }
                    }
                  },
                  [_vm._v("\n          " + _vm._s(type.title) + "\n        ")]
                )
              })
            ],
            2
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "all-results flex flex-between" }, [
          _c("div", { staticClass: "block results" }, [
            _vm.results.length
              ? _c("label", [_vm._v("Search Results")])
              : _c("label", [_vm._v("All Services")]),
            _vm._v(" "),
            _vm.results.length
              ? _c(
                  "div",
                  { staticClass: "wrap" },
                  _vm._l(_vm.results, function(link) {
                    return _c("a", { attrs: { href: link.url } }, [
                      _vm._v(
                        "\n            " + _vm._s(link.title) + "\n          "
                      )
                    ])
                  }),
                  0
                )
              : _c(
                  "div",
                  { staticClass: "wrap" },
                  _vm._l(_vm.all_services, function(link) {
                    return _c("a", { attrs: { href: link.url } }, [
                      _vm._v(
                        "\n            " + _vm._s(link.title) + "\n          "
                      )
                    ])
                  }),
                  0
                )
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "block popular" }, [
            _c("label", [_vm._v("Popular Searches")]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "wrap" },
              _vm._l(_vm.popular_searches, function(link) {
                return _c("a", { attrs: { href: link.url } }, [
                  _vm._v("\n            " + _vm._s(link.title) + "\n          ")
                ])
              }),
              0
            )
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "block recent" }, [
            _c("label", [_vm._v("Recently Viewed")]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "wrap" },
              _vm._l(_vm.recent, function(link) {
                return _c("a", { attrs: { href: link.url } }, [
                  _vm._v("\n            " + _vm._s(link.title) + "\n          ")
                ])
              }),
              0
            )
          ])
        ])
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4dd4d911", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4dd4d911","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/frontend/js/components/HeaderSearch.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-4dd4d911","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/frontend/js/components/HeaderSearch.vue
// module chunks = 0